<template>
    <div v-if="loaded" class="nevs-content">
        <div class="nevs-content-top-buttons">
            <NevsButton class="success help-save" @click="saveClick()"><i class="fa-solid fa-floppy-disk"></i>
                {{ $LANG.Get('buttons.save') }}
            </NevsButton>&nbsp;
            <NevsButton class="error help-back" @click="backClick"><i class="fa-solid fa-arrow-left"></i> {{
                    $LANG.Get('buttons.back')
                }}
            </NevsButton>
        </div>
        <NevsCard class="form">
            <NevsSelect v-model="contract.customer_id" :ajax="'select/customers'" :error="contractValidation.customer_id"
                        :label="$LANG.Get('fields.customer')"></NevsSelect>
            <NevsTextField v-model="contract.name" :error="contractValidation.name"
                           :label="$LANG.Get('fields.name')"></NevsTextField>
            <NevsDateField v-model="dateCreated" :error="contractValidation.date_created"
                           :label="$LANG.Get('fields.dateCreated')"></NevsDateField>
            <NevsDateField v-model="expirationDate" :error="contractValidation.expiration_date"
                           :label="$LANG.Get('fields.expirationDate')"></NevsDateField>
            <NevsSelect v-if="mode === 'add' && sequences.length > 1"
                        v-model="contract.contract_sequence_id"
                        :error="contractValidation.contract_sequence_id" :label="$LANG.Get('fields.sequence')"
                        :options="sequences"></NevsSelect>
            <NevsTextArea v-model="contract.note" :error="contractValidation.note"
                          :label="$LANG.Get('fields.note')"></NevsTextArea>
            <NevsUpload v-model="contract.uploaded_file" :label="$LANG.Get('fields.uploadedFile')"></NevsUpload>
            <NevsCheckbox v-model="contract.reminder" :label="$LANG.Get('fields.reminder')"></NevsCheckbox>
            <NevsNumberField v-if="contract.reminder" v-model="contract.reminder_days" :decimal-places="0"
                             :error="contractValidation.reminder_days"
                             :label="$LANG.Get('fields.reminderDays')"></NevsNumberField>
        </NevsCard>
    </div>
</template>

<script>
import Contract from '@/models/Contract.js';
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsDateField from "@/components/nevs/NevsDateField.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsTextArea from "@/components/nevs/NevsTextArea.vue";
import NevsUpload from "@/components/nevs/NevsUpload.vue";
import NevsCheckbox from "@/components/nevs/NevsCheckbox.vue";
import NevsNumberField from "@/components/nevs/NevsNumberField.vue";
import moment from "moment";

export default {
    name: "EntityContract",
    components: {
        NevsNumberField,
        NevsCheckbox,
        NevsUpload,
        NevsTextArea,
        NevsTextField,
        NevsDateField,
        NevsSelect,
        NevsButton,
        NevsCard
    },
    data() {
        return {
            loaded: false,
            mode: this.$route.params.mode,
            contract: new Contract({
                id: this.$route.params.id
            }),
            contractValidation: new Contract({}, true),
            dateCreated: null,
            expirationDate: null,
            sequences: []
        }
    },
    watch: {
        'dateCreated': function () {
            if (this.dateCreated !== null) {
                this.contract.date_created = this.dateCreated;
            }
        },
        'expirationDate': function () {
            if (this.expirationDate !== null) {
                this.contract.expiration_date = this.expirationDate;
            }
        }
    },
    methods: {
        backClick() {
            if (window.history.length === 1) {
                window.close();
            } else {
                this.$router.back();
            }
        },
        saveClick() {
            let success = true;

            if (this.contract.customer_id == null) {
                success = false;
                this.contractValidation.customer_id = this.$LANG.Get('labels.customerIdMissing');
            } else {
                this.contractValidation.customer_id = '';
            }

            if (this.contract.name === '') {
                success = false;
                this.contractValidation.name = this.$LANG.Get('labels.fieldMissing');
            } else {
                this.contractValidation.name = '';
            }

            if (this.contract.date_created == null) {
                success = false;
                this.contractValidation.date_created = this.$LANG.Get('labels.fieldMissing');
            } else {
                this.contractValidation.date_created = '';
            }

            if (this.contract.expiration_date == null) {
                success = false;
                this.contractValidation.expiration_date = this.$LANG.Get('labels.fieldMissing');
            } else {
                this.contractValidation.expiration_date = '';
            }

            if (this.contract.reminder && this.contract.reminder_days < 1) {
                success = false;
                this.contractValidation.reminder_days = this.$LANG.Get('labels.reminderDaysInvalid');
            } else {
                this.contractValidation.reminder_days = '';
            }

            if (success) {
                let data = JSON.parse(JSON.stringify(this.contract));
                let vm = this;
                let action = 'post';
                let addition = '';
                if (this.mode === 'edit') {
                    action = 'put';
                    addition = '/' + this.contract.id;
                }
                this.$API.APICall(action, 'contracts' + addition, data, (data, success) => {
                    if (success) {
                        vm.$CROSS_TAB_BUS.TriggerEvent('reload-contracts', {});
                        vm.$LOCAL_BUS.TriggerEvent('notification', {text: this.$LANG.Get('alerts.recordSaved')});
                        if (vm.mode === 'add') {
                            vm.backClick();
                        }
                    } else {
                        vm.$HELPERS.HandleServerError(vm, data);
                    }
                });
            }
        }
    },
    mounted() {
        this.$store.commit('setHelpOverlay', [
            {
                class: 'help-save',
                html: this.$LANG.Get('help.save'),
                left: -100,
                top: 0,
                width: 150
            },
            {
                class: 'help-back',
                html: this.$LANG.Get('help.back'),
                left: 85,
                top: -30,
                width: 300
            }
        ]);

        this.$store.commit('selectMenu', 'contracts');
        this.$store.commit('selectSubMenu', null);

        this.sequences = this.$store.state.user.contract_sequences;
        if (this.sequences.length > 0) {
            this.contract.contract_sequence_id = this.$store.state.user.default_contract_sequence_id;
        } else {
            this.$LOCAL_BUS.TriggerEvent('popup', {text: this.$LANG.Get('alerts.unauthorized'), type: 'alert'});
            this.$router.push('/');
        }

        if (this.mode === 'add') {
            this.$store.commit('setBreadcrumbs', [
                {
                    label: this.$LANG.Get('modules.contracts'),
                    link: '/contracts'
                },
                {
                    label: this.$LANG.Get('modules.newContract'),
                    link: null
                }
            ]);

            this.contract.date_created = moment().format('YYYY-MM-DD');
            this.dateCreated = moment().format('YYYY-MM-DD');

            this.$nextTick(() => {
                this.loaded = true;
            });
        } else if (this.mode === 'edit') {
            let vm = this;
            this.$API.APICall('get', 'contracts/' + this.contract.id, {}, (data, success) => {
                if (success) {
                    if (data.contract !== null) {
                        vm.contract.Fill(data.contract);
                        vm.dateCreated = data.contract.date_created;
                        vm.expirationDate = data.contract.expiration_date;
                        vm.$store.commit('setBreadcrumbs', [
                            {
                                label: vm.$LANG.Get('modules.contracts'),
                                link: '/contracts'
                            },
                            {
                                label: vm.contract.number,
                                link: null
                            }
                        ]);
                    } else {
                        vm.$HELPERS.HandleServerError(vm, data);
                    }
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
                vm.$nextTick(() => {
                    vm.loaded = true;
                });
            });
        }
    }
}
</script>

<style scoped>
.form {
    max-width: 600px;
    margin-bottom: 10px;
}
</style>